let accordeon = {
    init() {
        var nb = $('.block-facet--checkbox.facet-inactive .title').length;
        //console.log(nb);

        if(nb != 0){

            $(document).on('click', '.block-facet--checkbox.facet-inactive .title', function () {
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    $(this).next('.facets-widget-checkbox').slideUp(300);

                }else{
                    $('.block-facet--checkbox.facet-inactive .title').removeClass('active');
                    $(this).addClass('active');
                    $('.block-facet--checkbox.facet-inactive .facets-widget-checkbox').slideUp(300);
                    $(this).next('.facets-widget-checkbox').slideDown(300);
                }
            });

        }
    }
}

export default accordeon;
